import styled from 'styled-components';

import { CloseIcon, SearchIcon } from '../../../assets';
import { IconButton, Input } from '../../';

export const HeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-bottom: 1.5rem;
  }
`;
export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem 0.75rem 0rem 0.75rem;

  .nextui-input-main-container {
    margin-bottom: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0;
  }
`;

export const Title = styled.span`
  font-size: ${({ theme }) => theme.fontSize.m};
  line-height: ${({ theme }) => theme.lineHeight.ml};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.neutrals.black};
  align-self: flex-end;
  text-align: left;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.fontSize.l};
    line-height: ${({ theme }) => theme.lineHeight.l};
  }
`;

export const CloseButton = styled(IconButton)`
  width: 1rem;
  height: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-right: -0.75rem;
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  stroke: ${({ theme }) => theme.colors.primary.c300};
`;

export const StyledInput = styled(Input)`
  margin-bottom: 0;
  height: 2.25rem !important;
  input {
    margin-left: 0 !important;
  }
`;

export const StyledSearchIcon = styled(SearchIcon)`
  fill: none !important;
  stroke: ${({ theme }) => theme.colors.primary.c400};
`;
